module.exports = __webpack_public_path__ + "static/media/dormitorio-1.ad4a86d7.jpg";